<template>
  <div class="container">
     <div class="title-tab">
        <!-- <div class="title">{{tabShow==1?'Dayak Multispecies Knowledge Register Archive':'Archive Data Source'}}</div> -->
        <div class="btn-box">
            <div :class="tabShow==0?'btn btn-active':'btn'" @click="tabChange(0)">Home</div>
            <div :class="tabShow==1?'btn btn-active':'btn'" @click="tabChange(1)">Archive</div>
            <div :class="tabShow==2?'btn btn-active':'btn'" @click="tabChange(2)">Support</div>
        </div>
     </div>
     <div class="body bg" v-if="tabShow==0">
        <el-row :gutter="20">
          <el-col :span="7">
            <div class="home-left">
                <div class="top-blink">
                    <span class="blink">108</span><span class="times">times</span><br/>
                    <span style='font-weight:bolder;font-family: "courbd";color: #000;'>Participations</span><br/>
                    <span>and </span><span style="font-weight:bolder;font-family: 'courbd';color: #000;">Knowledge registration</span><br/>
                   <span>from the Dayak Simpang Tribe of west</span><br/>
                   <span>Kalimantan,Indonesia</span><br/>
              </div>
              <div class="dayal-box">
                   <span class="dayak-big more">Jalan Kita</span><br/>
                   <span class="dayak-big">Simpang Dayak multi-speccies knowledge archive</span><br/>
                   <span class="dayak"><span style='font-weight:bolder;font-family: "courbd";color: #000;'>Welcome</span>, this is an open platform to showcase</span><br/>
                   <span class="dayak">the vitality of the multi-species sound know- </span><br/>
                   <span class="dayak">ledge of the Dayak Simpang tribe, designed</span><br/>
                   <span class="dayak">for knowledge holders and continuously up-</span><br/>
                   <span class="dayak">dated for the public.</span>
              </div>
              <div class="bottom-box">
                   <span>RS2: Orang-Orang and the Hutan</span><br/>
                   <span>2022</span>
              </div>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="home-center">
              <div class="center-top">
                <el-row :gutter="10" style=" padding:40px 0 40px 0;">
                   <el-col :span="8" style=" display: flex;align-items: center;justify-content: center;">
                      <Player :id="0"/>
                  </el-col>
                  <el-col :span="8" style=" display: flex;align-items: center;justify-content: center;">
                      <Player :id="1"/>
                  </el-col>
                  <el-col :span="8" style=" display: flex;align-items: center;justify-content: center;">
                      <Player :id="2"/>
                  </el-col>
              </el-row>
              <el-row :gutter="10" style="padding:24px 0;display: flex;align-items: center;justify-content: center;">
                <el-col :span="8" style=" display: flex;align-items: center;justify-content: center;">
                  <Player :id="3"/>
                </el-col>
                <el-col :span="8" style=" display: flex;align-items: center;justify-content: center;">
                  <Player :id="4"/>
                </el-col>
                <el-col :span="8" style=" display: flex;align-items: center;justify-content: center;">
                  <Player :id="5"/>
                </el-col>
              </el-row>
              </div>
              <div class="center-bottom-box">
                <div class="bottom-title">
                  contact us
                </div>
                <div class="bottom-body">
                  <el-image :src="contactList[0]"  style="width: 30px; height: 30px" @click="topage(0)"></el-image>
                  <el-image :src="contactList[1]"  style="width: 30px; height: 30px" @click="topage(1)"></el-image>
                  <el-image :src="contactList[2]"  style="width: 30px; height: 30px" @click="topage(2)"></el-image>
                  <el-image :src="contactList[3]"  style="width: 30px; height: 30px" @click="topage(3)" id="copy" :data-clipboard-text="msg"></el-image>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="home-right"  @mouseenter="onEnterTd" @mouseleave="onLeaveTd">
              <div class="right-box" v-show="artShow">
                <p><span class="user-name">Jalan Kita</span>, , in collaboration with Arus kualan, is a constantly updated online archive of 
                  multispecies knowledge of the Dayak Simpang people of 
                  Indonesian West kalimantan to 
                  explore artistic tools to promote 
                  environmental justice and diversity activism.
                </p>
                <p style="margin-top:12px">
                  The project is based at the Royal College of Art, School of Architecture, environmental architecture.
                </p>
              </div>
            </div>
          </el-col>
        </el-row>
     </div>
     <div class="body" v-if="tabShow==1">
        <el-row :gutter="20">
          <el-col :span="10" style="padding:40px 32px 0px">
            <div class="data">
                <div class="tab-title">
                    <div :class="tabIndex==index?'tab-btn active':'tab-btn'" v-for="(item,index) in tabList" :key="index" @click="onBtn(index)">{{item}}</div>
                </div>
                <el-table
                  :data="tableData"
                  class="table-style"
                  size="mini"
                  height="calc((100vh - 132px)*0.5)"
                  >
                  <el-table-column
                    prop="name1"
                    label="NO."
                    width="50"
                    align="center"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="name2"
                    label="Image"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-image  :src="scope.row.name2"  style="width: 32px; height:32px;border-radius: 50%;"></el-image>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="name3"
                    label="Name">
                  </el-table-column>
                  <el-table-column
                    prop="name4"
                    align="center"
                    label="Number of uses">
                  </el-table-column>
                  <el-table-column
                    prop="name5"
                    align="center"
                    label="Time">
                  </el-table-column>
                </el-table>
            </div>
            <div class="log">
                <div class="tab-title">
                    <div class="tab-btn active">Data Log</div>
                </div>
                <el-table
                  :data="tableData2"
                  class="table-style"
                  size="mini"
                  height="calc((100vh - 132px)*0.3)"
                  >
                  <el-table-column
                    prop="name1"
                    label="NO."
                    width="50"
                    align="center"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="name2"
                    label="Number of button"
                    align="center"
                    >
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="name3"
                    label="Time">
                  </el-table-column>
                  <el-table-column
                    prop="name4"
                    align="center"
                    label="Location">
                  </el-table-column>
                  <el-table-column
                    prop="name5"
                    align="center"
                    label="Total">
                  </el-table-column>
                </el-table>
            </div>
          </el-col>
          <el-col :span="14">
            <div class="img-box">
                <el-image
                    style="width: 100%;height: 100%;border-radius: 8px;"
                    :src="mainImg"
                    fit="fill">
                </el-image>
                <el-image class="click0" :src="click" @click="changeImg(0)" v-if="isShow"></el-image>
                <el-image class="click1" :src="click" @click="changeImg(1)" v-if="isShow"></el-image>
                <el-image class="click2" :src="click" @click="changeImg(2)" v-if="isShow"></el-image>
                <el-image class="click3" :src="click" @click="changeImg(3)" v-if="isShow"></el-image>
                <el-image class="click4" :src="click" @click="changeImg(4)" v-if="isShow"></el-image>
                <el-image class="click5" :src="click" @click="changeImg(5)" v-if="isShow"></el-image>
            </div>
          </el-col>
        </el-row>
     </div>
     <div class="body" v-if="tabShow==2">
        <el-row :gutter="20">
            <el-col :span="12">
                <div class="support-box">
                    <div class="support-title">Sound Capture Device</div>
                    <div class="select-box">
                        <div :class="leftSelect==1?'select-btn select-active':'select-btn'" @click="changeLeftSelect(1)" style="border-top-left-radius: 5px;">operation photos</div>
                        <div :class="leftSelect==2?'select-btn select-active':'select-btn'" @click="changeLeftSelect(2)" style="border-top-right-radius: 5px;">schematic</div>
                    </div>
                    <div class="support-body">
                        <div class="next-btn" @click="leftImgChange(-1)" v-if="leftSelect==1">
                            <i v-if="leftImgIndex==0" class="el-icon-arrow-left" style="font-size:36px;color:#ccc"></i>
                            <i v-else class="el-icon-arrow-left" style="font-size:36px"></i>
                        </div>
                        <div class="img-show">
                            <el-image
                                style="width: 100%; height: 100%;text-align: center;"
                                :src="leftImg"
                                fit="scale-down"></el-image>
                        </div>
                        <div class="next-btn" @click="leftImgChange(1)" v-if="leftSelect==1">
                            <i v-if="leftImgIndex==2" class="el-icon-arrow-right" style="font-size:36px;color:#ccc"></i>
                            <i v-else class="el-icon-arrow-right" style="font-size:36px"></i>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="12">
                <div class="support-box">
                    <div class="support-title">Register Button</div>
                    <div class="select-box">
                        <div :class="rightSelect==1?'select-btn select-active':'select-btn'" @click="changeRightSelect(1)" style="border-top-left-radius: 5px;">operation photos</div>
                        <div :class="rightSelect==2?'select-btn select-active':'select-btn'" @click="changeRightSelect(2)" style="border-top-right-radius: 5px;">schematic</div>
                    </div>
                    <div class="support-body">
                        <div class="next-btn" @click="rightImgChange(-1)" v-if="rightSelect==1">
                            <i v-if="rightImgIndex==0" class="el-icon-arrow-left" style="font-size:36px;color:#ccc"></i>
                            <i v-else class="el-icon-arrow-left" style="font-size:36px;"></i>
                        </div>
                        <div class="img-show">
                            <el-image
                                style="width: 100%; height: 100%;text-align: center;"
                                :src="rightImg"
                                fit="scale-down"></el-image>
                        </div>
                        <div class="next-btn" @click="rightImgChange(1)" v-if="rightSelect==1">
                            <i v-if="rightImgIndex==1" class="el-icon-arrow-right" style="font-size:36px;color:#ccc"></i>
                            <i v-else class="el-icon-arrow-right" style="font-size:36px;"></i>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
     </div>
  </div>
</template>

<script>
import logo1 from "@/assets/logo1.png"
import logo2 from "@/assets/logo2.png"
import logo3 from "@/assets/logo3.png"
import logo4 from "@/assets/logo4.png"
import main from "@/assets/main2.gif"
import sample1 from "@/assets/01.gif"
import sample2 from "@/assets/02.gif"
import sample3 from "@/assets/03.gif"
import sample4 from "@/assets/04.gif"
import sample5 from "@/assets/05.gif"
import sample6 from "@/assets/06.gif"
import click from "@/assets/click.png"
import button from "@/assets/button.jpg"
import button1 from "@/assets/button1.jpg"
import button2 from "@/assets/button2.jpg"
import device from "@/assets/device.jpg"
import device1 from "@/assets/device1.jpg"
import device2 from "@/assets/device2.jpg"
import device3 from "@/assets/device3.jpg"
import Player from '@/components/Player';
import play1 from "@/assets/play1.png"
import play2 from "@/assets/play2.png"
import play3 from "@/assets/play3.png"
import play4 from "@/assets/play4.png"
import play5 from "@/assets/play5.png"
import play6 from "@/assets/play6.png"
import Clipboard from 'clipboard';
export default {
  name: 'Index',
  components:{
    Player
  },
  data() {
    return {
        msg:"simpangdayaksoundarchive@gmail.com",
        dayData: [{
          name1: '01',
          name2: play1,
          name3: 'Serendipity',
          name4: '6',
          name5: '07/11/2023',
        },{
          name1: '02',
          name2: play2,
          name3: 'Incalescence',
          name4: '2',
          name5: '07/11/2023',
        },{
          name1: '03',
          name2: play3,
          name3: 'Jieopardy',
          name4: '2',
          name5: '07/11/2023',
        },{
          name1: '04',
          name2: play4,
          name3: 'Pest',
          name4: '1',
          name5: '07/11/2023',
        },{
          name1: '05',
          name2: play5,
          name3: 'Humid',
          name4: '3',
          name5: '07/11/2023',
        },{
          name1: '06',
          name2: play6,
          name3: 'Ghost',
          name4: '0',
          name5: '07/11/2023',
        }],
        weekData: [{
          name1: '01',
          name2: play1,
          name3: 'Serendipity',
          name4: '26',
          name5: '31/10/2023~07/11/2023',
        },{
          name1: '02',
          name2: play2,
          name3: 'Incalescence',
          name4: '29',
          name5: '31/10/2023~07/11/2023',
        },{
          name1: '03',
          name2: play3,
          name3: 'Jieopardy',
          name4: '19',
          name5: '31/10/2023~07/11/2023',
        },{
          name1: '04',
          name2: play4,
          name3: 'Pest',
          name4: '5',
          name5: '31/10/2023~07/11/2023',
        },{
          name1: '05',
          name2: play5,
          name3: 'Humid',
          name4: '22',
          name5: '31/10/2023~07/11/2023',
        },{
          name1: '06',
          name2: play6,
          name3: 'Ghost',
          name4: '5',
          name5: '31/10/2023~07/11/2023',
        }],
        monthData: [{
          name1: '01',
          name2: play1,
          name3: 'Serendipity',
          name4: '143',
          name5: '07/10/2023~07/11/2023',
        },{
          name1: '02',
          name2: play2,
          name3: 'Incalescence',
          name4: '126',
          name5: '07/10/2023~07/11/2023',
        },{
          name1: '03',
          name2: play3,
          name3: 'Jieopardy',
          name4: '134',
          name5: '07/10/2023~07/11/2023',
        },{
          name1: '04',
          name2: play4,
          name3: 'Pest',
          name4: '71',
          name5: '07/10/2023~07/11/2023',
        },{
          name1: '05',
          name2: play5,
          name3: 'Humid',
          name4: '128',
          name5: '07/10/2023~07/11/2023',
        },{
          name1: '06',
          name2: play6,
          name3: 'Ghost',
          name4: '62',
          name5: '07/10/2023~07/11/2023',
        }],
        yearData: [{
          name1: '01',
          name2: play1,
          name3: 'Danger',
          name4: '1912',
          name5: '07/11/2022~07/11/2023',
        },{
          name1: '02',
          name2: play2,
          name3: 'Danger',
          name4: '2013',
          name5: '07/11/2022~07/11/2023',
        },{
          name1: '03',
          name2: play3,
          name3: 'Danger',
          name4: '2249',
          name5: '07/11/2022~07/11/2023',
        },{
          name1: '04',
          name2: play4,
          name3: 'Lucky',
          name4: '1895',
          name5: '07/11/2022~07/11/2023',
        },{
          name1: '05',
          name2: play5,
          name3: 'Ghost',
          name4: '2351',
          name5: '07/11/2022~07/11/2023',
        },{
          name1: '06',
          name2: play6,
          name3: 'Ghost',
          name4: '692',
          name5: '07/11/2022~07/11/2023',
        }],
        tableData:[],
        tabList:["Day","Week","Month","Year"],
        tabIndex:0,
        tableData2:[{
            name1:'9819',
            name2:'Humid',
            name3:'07/11/2023',
            name4:'Forest Restaurant',
            name5:'2351',
        },{
            name1:'9818',
            name2:'serendipity',
            name3:'07/11/2023',
            name4:'Forest Restaurant',
            name5:'1912',
        },{
            name1:'9817',
            name2:'Jieopardy',
            name3:'06/11/2023',
            name4:'Forest Restaurant',
            name5:'2249',
        },{
            name1:'9816',
            name2:'Humid',
            name3:'06/11/2023',
            name4:'Forest Restaurant',
            name5:'2350',
        },{
            name1:'9815',
            name2:'Ghost',
            name3:'06/11/2023',
            name4:'Forest Restaurant',
            name5:'692',
        },{
            name1:'9814',
            name2:'Serendipity',
            name3:'06/11/2023',
            name4:'Forest Restaurant',
            name5:'1911',
        },{
            name1:'9813',
            name2:'Pest',
            name3:'05/11/2023',
            name4:'Forest Restaurant',
            name5:'1895',
        },{
            name1:'9812',
            name2:'Incalescence',
            name3:'05/11/2023',
            name4:'Forest Restaurant',
            name5:'2013',
        },{
            name1:'9811',
            name2:'Jieopardy',
            name3:'05/11/2023',
            name4:'Forest Restaurant',
            name5:'2248',
        },{
            name1:'9810',
            name2:'Pest',
            name3:'04/11/2023',
            name4:'Forest Restaurant',
            name5:'1894',
        },{
            name1:'9809',
            name2:'Humid',
            name3:'04/11/2023',
            name4:'Forest Restaurant',
            name5:'2349',
        },{
            name1:'9808',
            name2:'Serendipity',
            name3:'04/11/2023',
            name4:'Forest Restaurant',
            name5:'1910',
        },{
            name1:'9807',
            name2:'Incalescence',
            name3:'04/11/2023',
            name4:'Forest Restaurant',
            name5:'2012',
        }],
        mainImg:main,
        click:click,
        isShow:true,
        tabShow:0,
        leftImg:device1,
        leftSelect:1,
        leftImgIndex:0,
        leftImgList:[device1,device2,device3],
        rightImg:button1,
        rightSelect:1,
        rightImgIndex:0,
        rightImgList:[button1,button2],
        artShow:false,
        sampleList:[sample1,sample2,sample3,sample4,sample5,sample6],
        contactList:[logo1,logo2,logo3,logo4]
    }
  },
  created() {
    this.init();
  },

  methods: {
    init(){
        this.tableData = this.dayData
    },
    copy () {
      let _this = this
      let clipboard = new Clipboard('#copy')
      //复制成功
      clipboard.on('success', e => {
        _this.$message.success('Sound archive email address copied!')
          // 释放内存
          clipboard.destroy()
        })
      //复制失败
      clipboard.on('error', e => {
        _this.$message.error('复制失败！')
        clipboard.destory()
      })
    },
    topage(type){
      if(type == 0){
        window.location.href = "https://twitter.com/Dsoundarchive"
      }else if(type == 1){
        window.location.href = "https://www.instagram.com/soundknowledge_archive/"
      }else if(type == 2){
        window.location.href = "https://www.facebook.com/profile.php?id=100088068246818"
      }else if(type == 3){
        this.copy()
      }
    },
    //鼠标进入的事件。
    onEnterTd(e) {
      this.artShow = true
    },
    //鼠标离开的事件。
    onLeaveTd(e) {
      this.artShow = false
    },
    onBtn(index){
        this.tabIndex = index
        if(index == 0){
            this.tableData = this.dayData
        }else if(index == 1){
             this.tableData = this.weekData
        }else if(index == 2){
             this.tableData = this.monthData
        }else if(index == 3){
             this.tableData = this.yearData
        }
    },
    changeImg(index){
        this.mainImg = this.sampleList[index],
        this.isShow = false
        setTimeout(()=>{
            this.mainImg = main
            this.isShow = true
        }, 6000 )
    },
    tabChange(index){
        this.tabShow = index
    },
    changeLeftSelect(index){
        this.leftSelect = index
        this.leftImgIndex = 0
        if(index == 1){
            this.leftImg = device1
        }else{
            this.leftImg = device
        }
    },
    leftImgChange(index){
        if(index == 1){
            if(this.leftImgIndex == 2){
                return
            }
            this.leftImg = this.leftImgList[this.leftImgIndex+1]
            this.leftImgIndex = this.leftImgIndex+1
        }else{
            if(this.leftImgIndex == 0){
                return
            }
            this.leftImg = this.leftImgList[this.leftImgIndex-1]
            this.leftImgIndex = this.leftImgIndex-1
        }
    },
    
    changeRightSelect(index){
        this.rightSelect = index
        this.rightImgIndex = 0
        if(index == 1){
            this.rightImg = button1
        }else{
            this.rightImg = button
        }
    },

    rightImgChange(index){
        if(index == 1){
            if(this.rightImgIndex == 1){
                return
            }
            this.rightImg = this.rightImgList[this.rightImgIndex+1]
            this.rightImgIndex = this.rightImgIndex+1
        }else{
            if(this.rightImgIndex == 0){
                return
            }
            this.rightImg = this.rightImgList[this.rightImgIndex-1]
            this.rightImgIndex = this.rightImgIndex-1
        }
    },
  }
}
</script>
<style lang="less">
.el-table th, .el-table tr {
    background-color: #F0F0F0;
}
.el-table .cell{
  line-height: 35px;
  padding-right: 5px;
}
</style>
<style lang="less" scoped>
*{
  padding: 0;
  margin: 0;
}
.el-table{
  border-radius: 5px;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar{
  width: 6px;
  height: 6px;
  border-radius: 5px;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb{
  background-color: rgb(159, 159, 159);
  border-radius: 5px;
}
.container {
  min-height: calc(~"100vh - 22px");
  width: 100%;
//   background-color: #CCC;
  overflow: hidden;
  .title-tab{
    // border-bottom: 1px solid #000;
    display: flex;
    padding: 10px 10% 0;
    justify-content: space-between;
    align-items: center;
    justify-content: center;
    .title{
        font-weight: 800;
        font-size: 18px;
    }
    .btn-box{
        display: flex;
    }
    .btn{
        padding: 10px 30px;
        border-bottom: 6px solid rgb(202, 200, 200);
        font-size: 20px;
        cursor: pointer;
        font-weight: 800;
        margin: 0 30px;
        font-family: "courbd";
    }
    .btn-active{
        border-bottom: 6px solid #000;
    }
  }
  .bg{
    background-image: url("@/assets/bg.jpg");
    background-size: 100% 100%;
  }
  .body{
    // background-color: red;
    min-height: calc(~"100vh - 92px");
    width: 100%;
    .data{
        min-height: calc(~"(100vh - 132px)*0.57");
        width: 100%;
        margin-bottom: 12px;
    }
    .log{
        min-height: calc(~"(100vh - 132px)*0.38");
        width: 100%;
    }
    .tab-title{
        display: flex;
        background-color: #F0F0F0;
        width: fit-content;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }
    .table-style{
        background-color: #F0F0F0;
        width: 100%;
    }
    .tab-btn{
        padding: 10px 20px;
        color: #8F8F8F;
        cursor: pointer;
    }
    .active{
        background-image: linear-gradient(#C3C2C2, #DDDDDD);
        color: #000;
        font-weight: bold;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }
    .img-box{
        height: calc(~"(100vh - 180px)");
        width: 95%;
        margin-top: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }
    .click0{
        position: absolute;
        top: 62%;
        left: 17%;
        width: 20px;
        height: 20px;
        z-index: 100;
        cursor: pointer;
        animation: blink 1.5s linear infinite;  
        /* 其它浏览器兼容性前缀 */
        -webkit-animation: blink 1.5s linear infinite;
        -moz-animation: blink 1.5s linear infinite;
       -ms-animation: blink 1.5s linear infinite;
        -o-animation: blink 1.5s linear infinite;
    }
    .click1{
        position: absolute;
        top: 69%;
        left: 17%;
        width: 20px;
        height: 20px;
        z-index: 100;
        cursor: pointer;
        animation: blink 1.8s linear infinite;  
        /* 其它浏览器兼容性前缀 */
        -webkit-animation: blink 1.8s linear infinite;
        -moz-animation: blink 1.8s linear infinite;
       -ms-animation: blink 1.8s linear infinite;
        -o-animation: blink 1.8s linear infinite;
    }
    .click2{
        position: absolute;
        top: 61%;
        left: 38%;
        width: 20px;
        height: 20px;
        z-index: 100;
        cursor: pointer;
        animation: blink 2.2s linear infinite;  
        /* 其它浏览器兼容性前缀 */
        -webkit-animation: blink 2.2s linear infinite;
        -moz-animation: blink 2.2s linear infinite;
       -ms-animation: blink 2.2s linear infinite;
        -o-animation: blink 2.2s linear infinite;
    }
    .click3{
        position: absolute;
        top: 68%;
        left: 37%;
        width: 20px;
        height: 20px;
        z-index: 100;
        cursor: pointer;
        animation: blink 2.5s linear infinite;  
        /* 其它浏览器兼容性前缀 */
        -webkit-animation: blink 2.5s linear infinite;
        -moz-animation: blink 2.5s linear infinite;
       -ms-animation: blink 2.5s linear infinite;
        -o-animation: blink 2.5s linear infinite;
    }
    .click4{
        position: absolute;
        top: 61%;
        left: 82%;
        width: 20px;
        height: 20px;
        z-index: 100;
        cursor: pointer;
        animation: blink 2.8s linear infinite;  
        /* 其它浏览器兼容性前缀 */
        -webkit-animation: blink 2.8s linear infinite;
        -moz-animation: blink 2.8s linear infinite;
       -ms-animation: blink 2.8s linear infinite;
        -o-animation: blink 2.8s linear infinite;
    }
    .click5{
        position: absolute;
        top: 80%;
        left: 81%;
        width: 20px;
        height: 20px;
        z-index: 100;
        cursor: pointer;
        animation: blink 3s linear infinite;  
        /* 其它浏览器兼容性前缀 */
        -webkit-animation: blink 3s linear infinite;
        -moz-animation: blink 3s linear infinite;
       -ms-animation: blink 3s linear infinite;
        -o-animation: blink 3s linear infinite;
    }
    .support-box{
        height: calc(~"100vh - 140px");
        padding:24px 24px 0 24px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .support-title{
            font-weight: bold;
            width: 100%;
            text-align: center;
            margin-bottom: 12px;
        }
        .select-box{
            display: flex;
            width: 80%;
            // border: 1px solid #000;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            .select-btn{
                width: 50%;
                padding: 6px 12px;
                background-color: #fff;
                color: #000;
                text-align: center;
                cursor: pointer;
                border: 1px solid #000;
            }
            .select-active{
                background-color: #000;
                color: #fff;
            }
        }
        .support-body{
            background-color: #F0F0F0;
            width: 80%;
            height: calc(~"100vh - 180px");
            border-radius: 5px;
            display: flex;
            align-items: center;
            padding: 12px 0;
            justify-content: center;
            .next-btn{
                display: block;
                width: 10%;
                text-align: center;
                cursor: pointer;
            }
            .img-show{
                width: 80%;
                height: calc(~"100vh - 200px");
            }
        }
    }
  }
  .home-left{
     min-height: calc(~"(100vh - 92px)");
     padding: 0 36px;
     position: relative;
    .times{
      font-weight: bolder;
      font-size: 24px;
      color: #000;
      font-family: 'courbd';
    }
    /* 定义keyframe动画，命名为blink */
    @keyframes blink{
      0%{opacity: 1;}

      100%{opacity: 0;} 
    }
    /* 添加兼容性前缀 */
    @-webkit-keyframes blink {
        0% { opacity: 1; }
        100% { opacity: 0; }
    }
    @-moz-keyframes blink {
        0% { opacity: 1; }
        100% { opacity: 0; }
    }
    @-ms-keyframes blink {
        0% {opacity: 1; } 
        100% { opacity: 0;}
    }
    @-o-keyframes blink {
        0% { opacity: 1; }
        100% { opacity: 0; }
    }
 /* 定义blink类*/
    .blink{
        color: #000;
        font-size:60px;
        font-weight: bolder;
        margin-right: 6px;
        font-family: "courbd";
        animation: blink 2s linear infinite;  
        /* 其它浏览器兼容性前缀 */
        -webkit-animation: blink 2s linear infinite;
        -moz-animation: blink 2s linear infinite;
       -ms-animation: blink 2s linear infinite;
        -o-animation: blink 2s linear infinite;
    }
    .top-blink{
      padding-top: 20px;
      margin-left: 10px;
      font-family: "courbd";
      color:#636262;
    }
    .dayal-box{
      position: absolute;
      // height: 500px;
      width: 70%;
      bottom: 60px;
      left: 40px;
      writing-mode:vertical-rl;
      transform: rotate(180deg);
    }
    .dayak-big{
      font-size: 24px;
      font-weight: bolder;
      font-family: "AcuminVariableConcept";
    }
    .more{
      font-size: 30px;
    }
    .dayak{
      font-size: 16px;
      font-family: "courbd";
      color:#636262;
    }
    .bottom-box{
      position: absolute;
      bottom: 20px;
      left: 42px;
      text-align: right;
      font-family: "courbd";
      color:#636262;
    }
  }
  .home-center{
   min-height: calc(~"(100vh - 92px)");
   position: relative;
   .center-top{
    min-height: calc(~"(100vh - 92px)*0.8");
    display: flex;
    flex-direction: column;
    justify-content: center;

   }
   .center-bottom-box{
    position: absolute;
    bottom: 30px;
    left: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .bottom-title{
      width: 40%;
      margin-bottom: 12px;
      text-align: center;
      font-size: 24px;
      font-family: "courbd";
      color:#636262;
    }
    .bottom-body{
      width: 30%;
      display: flex;
      justify-content: space-around;
    }
   }
  }
  .home-right{
    min-height: calc(~"(100vh - 92px)");
    display: flex;
    flex-direction: column;
    justify-content: center;
    .right-box{
      padding: 0 15%;
      display: block;
      cursor: pointer;
      line-height: 30px;
      font-family: "courbd";
      color:#636262;
    }
  }
   
}
.user-name{
  font-family: "AcuminVariableConcept";
  font-weight: bolder;
  color: #000;
}
</style>
